export default "__VITE_ASSET__c9125d54__"